import { render, staticRenderFns } from "./streamSourcesSidebar.vue?vue&type=template&id=0f355682&scoped=true&"
import script from "./streamSourcesSidebar.vue?vue&type=script&lang=js&"
export * from "./streamSourcesSidebar.vue?vue&type=script&lang=js&"
import style0 from "./streamSourcesSidebar.vue?vue&type=style&index=0&id=0f355682&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f355682",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VIcon,VSheet})
